import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isVisible: false,
    contentId: null,
    props: {},
};

const expandableColumnSlice = createSlice({
    name: 'expandableColumn',
    initialState,
    reducers: {
        toggleExpandableColumn: (state, action) => {
            const { contentId, props } = action.payload;

            // Check if the column is open with the same content
            if (state.isVisible && state.contentId === contentId) {
                state.isVisible = false;
                state.contentId = null;
                state.props = {};
            } else {
                state.isVisible = true;
                state.contentId = contentId;
                state.props = props || {};
            }
        },
        closeExpandableColumn: (state) => {
            state.isVisible = false;
            state.contentId = null;
            state.props = {};
        },
        updateExpandableColumnContent: (state, action) => {
            const { contentId, props } = action.payload;
            state.contentId = contentId;
            state.props = props || {};
        },
    },
});

export const { toggleExpandableColumn, closeExpandableColumn, updateExpandableColumnContent } = expandableColumnSlice.actions;
export default expandableColumnSlice.reducer;
